<template>
  <div>
    <div class="custom-table" ref="tableContainer">
      <div v-if="isMobile" class="custom-table--fixed-wrapper" :style="{ width: fixedWidth }">
        <div class="custom-table--header-wrapper">
          <table
            class="table table-bordered"
            :style="{ width: tableWidth}"
            @touchmove="this.onPreventTouch"
          >
            <colgroup v-for="(item, i) in colls" :key="i" :width="item" align="center"></colgroup>
            <tr>
              <th>排行</th>
              <th>参赛者</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </table>
        </div>

        <div class="custom-table--body-wrapper is-fixed">
          <table
            class="table table-hover table-bordered"
            :style="{ width: tableWidth, transform: 'translate(0, ' + -scrollTop + 'px)' }"
          >
            <colgroup v-for="(item, i) in colls" :key="i" :width="item" align="center"></colgroup>
            <tr 
              v-for="(item, i) in list"
              :key="item.userId"
              :class="{ focus: item.userId === currentFocus}"
            >
              <td>
                <div class="cell">
                  <img v-if="item.ranking === 1" src="../../assets/num1.png" class="cell-icon" alt />
                  <img v-else-if="item.ranking === 2" src="../../assets/num2.png" class="cell-icon" alt />
                  <img v-else-if="item.ranking === 3" src="../../assets/num3.png" class="cell-icon" alt />
                  <span v-else style="font-size: 17px; font-weight: 500">{{ item.ranking }}</span>
                </div>
              </td>
              <td>
                <div class="cell" style="display: flex; align-items: center;" :style="{ paddingLeft: !isLastWeek && weekOrTotal !== 'total' ? '12%' : '' }">
                  <div
                    style="display: inline-block; width: 22px; height: 22px; overflow: hidden; border-radius: 100%; margin-right: 6px;"
                  >
                    <img :src="item.avatar" width="100%" />
                  </div>

                  <div class="name-cell" style="">{{ item.nick }}</div>

                  <img
                    v-if="i === 0 && isLastWeek && weekOrTotal === 'week'"
                    :src="group === 1 ? lightChampion : strongChampion"
                    class="champion"
                  >

                  <div v-if="weekOrTotal === 'total' && item.weekRanking" class="total-champion">
                    <span>{{ item.weekRanking }}</span>
                  </div>
                </div>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>

        <div v-if="ownRanking.userId && ownRanking.team === group" class="custom-table--footer-wrapper is-fixed">
          <table class="table table-bordered" :style="{ width: tableWidth }">
            <colgroup v-for="(item, i) in colls" :key="i" :width="item" align="center"></colgroup>
            <tr>
              <td>
                <div class="cell">
                  <img v-if="ownRanking.ranking === 1" src="../../assets/num1.png" width="30" alt />
                  <img v-else-if="ownRanking.ranking === 2" src="../../assets/num2.png" width="30" alt />
                  <img v-else-if="ownRanking.ranking === 3" src="../../assets/num3.png" width="30" alt />
                  <span v-else>{{ ownRanking.ranking }}</span>
                </div>
              </td>
              <td>
                <div class="cell" style="display: flex; align-items: center;" :style="{ paddingLeft: !isLastWeek && weekOrTotal !== 'total' ? '12%' : '' }">
                  <div
                    style="display: inline-block; width: 22px; height: 22px; overflow: hidden; border-radius: 100%; margin-right: 6px;"
                  >
                    <img :src="ownRanking.avatar" width="100%" />
                  </div>
                  <div class="name-cell" style=" text-align: left">{{ ownRanking.nick }}</div>
                </div>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>

      <div class="custom-table--header-wrapper" ref="scrollHeader">
        <table class="table table-bordered gutter" :style="{ width: tableWidth }">
          <colgroup v-for="(item, i) in colls" :key="i" :width="item" align="center"></colgroup>
          <tr>
            <th>排行</th>
            <th>参赛者</th>
            <th>综合得分</th>
            <th>最大本金收益率</th>
            <th>最大回撤率</th>
            <th>累计净利润</th>
          </tr>
        </table>
      </div>

      <div class="custom-table--body-wrapper" ref="scrollBody">
        <table class="table table-hover table-bordered" :style="{ width: tableWidth }">
          <colgroup v-for="(item, i) in colls" :key="i" :width="item" align="center"></colgroup>
          <tr
            v-for="(item, i) in list"
            :key="item.userId"
            :class="{ focus: item.userId === currentFocus}"
          >
            <td>
              <div class="cell">
                <img v-if="item.ranking === 1" src="../../assets/num1.png" width="30" alt />
                <img v-else-if="item.ranking === 2" src="../../assets/num2.png" width="30" alt />
                <img v-else-if="item.ranking === 3" src="../../assets/num3.png" width="30" alt />
                <span v-else>{{ item.ranking }}</span>
              </div>
            </td>
            <td>
              <div class="cell" style="display: flex; align-items: center;" :style="{ paddingLeft: !isLastWeek && weekOrTotal !== 'total' ? '12%' : '' }">
                <div
                  style="display: inline-block; width: 22px; height: 22px; overflow: hidden; border-radius: 100%; margin-right: 6px; flex-shrink: 0"
                >
                  <img :src="item.avatar" width="100%" />
                </div>
                <div class="name-cell" style=" min-width: 48px">{{ item.nick }}</div>
                <img
                  v-if="i === 0 && isLastWeek && weekOrTotal === 'week'"
                  :src="group === 1 ? lightChampion : strongChampion"
                  class="champion"
                >

                <div v-if="weekOrTotal === 'total' && item.weekRanking" class="total-champion">
                  <span class="champion__text">{{ item.weekRanking }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="cell">{{ item.overallRatings.toFixed(2) }}</div>
            </td>
            <td>
              <div class="cell">{{ (item.principalYield * 100).toFixed(2) + "%" }}</div>
            </td>
            <td>
              <div class="cell">{{ (item.maxWithdrawalRate * 100).toFixed(2)  + "%" }}</div>
            </td>
            <td>
              <div class="cell">{{ (item.amount / 100).toFixed(2) }}</div>
            </td>
            <!-- <td @mouseenter="e => onMouseEnter(item, e)" @mouseleave="onMouseLeave" @click="e => onClick(item, e)">
              <div class="cell cell-number">{{ item.entrustNumber }}</div>
            </td> -->
          </tr>

          <tr v-if="list.length === 0">
            <td colspan="6">
              <!-- 暂无数据 -->
            </td>
          </tr>
        </table>
      </div>

      <div v-if="ownRanking.userId && ownRanking.team === group" class="custom-table--footer-wrapper" ref="scrollFooter">
        <table class="table table-bordered" :style="{ width: tableWidth }">
          <colgroup v-for="(item, i) in colls" :key="i" :width="item" align="center"></colgroup>

          <tr>
            <td>
              <div class="cell">
                <img v-if="ownRanking.ranking === 1" src="../../assets/num1.png" width="30" alt />
                <img
                  v-else-if="ownRanking.ranking === 2"
                  src="../../assets/num2.png"
                  width="30"
                  alt
                />
                <img
                  v-else-if="ownRanking.ranking === 3"
                  src="../../assets/num3.png"
                  width="30"
                  alt
                />
                <span v-else>{{ ownRanking.ranking }}</span>
              </div>
            </td>
            <td>
              <div class="cell" style="display: flex; align-items: center;" :style="{ paddingLeft: !isLastWeek && weekOrTotal !== 'total' ? '12%' : '' }">
                <div
                  style="display: inline-block; width: 22px; height: 22px; overflow: hidden; border-radius: 100%; margin-right: 6px;"
                >
                  <img :src="ownRanking.avatar" width="100%" />
                </div>
                <div class="name-cell" style=" text-align: left;">{{ ownRanking.nick }}</div>
              </div>
            </td>
            <td>
              <div class="cell">{{ (ownRanking.overallRatings * 1).toFixed(2) }}</div>
            </td>
            <td>
              <div class="cell">{{ (ownRanking.principalYield * 100).toFixed(2) + "%" }}</div>
            </td>
            <td>
              <div class="cell">{{ (ownRanking.maxWithdrawalRate * 100).toFixed(2)  + "%" }}</div>
            </td>
            <td>
              <div class="cell">{{ (ownRanking.amount / 100).toFixed(2) }}</div>
            </td>
            <!-- <td @mouseenter="e => onMouseEnter(ownRanking, e)" @mouseleave="onMouseLeave" @click="e => onClick(ownRanking, e)">
              <div class="cell cell-number">{{ ownRanking.entrustNumber }}</div>
            </td> -->
          </tr>
        </table>
      </div>
    </div>

    <transition name="fade">
      <div v-if="showPopup" class="popup" ref="popup">
        <div class="popup-container">
          <div v-for="item in contestOrderHandsTotalList" :key="item.contractId" style="margin-bottom: 2px;">
            <span style="margin-right: 6px;">品种：{{ item.contractId }}</span><span>手数：{{ item.hands }}</span>
          </div>
        </div>
      </div>
    </transition>

    <!-- 暂时 -->
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import device from "@jin10/utils/lib/device";
import {
  getUsersByIds,
  getWeekRankingByUser,
  getTotalRankingByUser,
  getTopTotalRanking,
  getTopWeekRanking
} from "@/api";
import lightChampion from '../../assets/light-champion.png'
import strongChampion from '../../assets/strong-champion.png'

const localStr = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"]

export default {
  name: "Table",
  props: {
    group: {
      type: Number,
      default: 1,
      validator: value => [1, 2].indexOf(value) !== -1
    },
    weekOrTotal: {
      type: String,
      default: "total",
      validator: value => ["total", "week"].indexOf(value) !== -1
    },
    week: String,
    user: [Object, null],
    isLastWeek: {
      type: Boolean,
      default: false
    },
    weeksOptions: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data() {
    return {
      size: 10,
      list: [],
      current: 1,
      total: 0,
      pages: 1,
      localCurrent: 1,
      tableWidth: "100%",
      isMobile: false,
      fixedWidth: "",
      scrollTop: 0,
      scrollLeft: 0,
      ownRanking: {},
      currentFocus: 0,
      showPrevMore: false,
      showNextMore: false,
      showPopup: false,
      contestOrderHandsTotalList: [],
      lightChampion,
      strongChampion,
      colls: ['10.66666%', '21.66666%', '16.66666%', '17.66666%', '16.66666%', '16.66666%']
    };
  },
  computed: {
    options() {
      return new Array(this.pages).fill(0).map((_, i) => ({
        value: i + 1,
        label: i + 1
      }));
    }
  },
  mounted() {
    this.getList();
    this.getOwnRanking();
    
    if (device.isMobile) {
      this.isMobile = device.isMobile;
      this.tableWidth = "800px";
      this.fixedWidth = `${parseInt(this.tableWidth) * (((parseFloat(this.colls[0]) + parseFloat(this.colls[1])) / 100))}px`;

      this.$refs.tableContainer.addEventListener("touchstart", e => {
        this.startX = e.touches[0].clientX
        this.startY = e.touches[0].clientY
        this.scrollLeft = this.$refs.scrollBody.scrollLeft

        this.onMouseLeave()
      });

      this.$refs.tableContainer.addEventListener("touchmove", e => {
        const x = e.touches[0].clientX
        const diffX = (x - this.startX) * 1.25

        if (Math.abs(x - this.startX) > 5) {
          e.preventDefault()
        }

        this.$refs.scrollHeader.scrollLeft = this.scrollLeft - diffX;
        this.$refs.scrollBody.scrollLeft = this.scrollLeft - diffX;

        if (this.$refs.scrollFooter) {
          this.$refs.scrollFooter.scrollLeft = this.scrollLeft - diffX;
        }

        return false
      });
    }

    setInterval(() => {
      this.getList()
      this.getOwnRanking()
    }, 3600 * 1000)

    // document.addEventListener('scroll', () => {
    //   this.showPopup = false
    // })
  },
  methods: {
    onMouseLeave() {
      clearTimeout(this.timer)
      this.showPopup = false
    },
    onMouseEnter(data, e) {
      if (!device.isMobile) {
        this.contestOrderHandsTotalList = this.weekOrTotal === 'week' ? data.contestOrderHandsWeekList : data.contestOrderHandsTotalList
        if (!this.contestOrderHandsTotalList.length) {
          return
        }

        this.handlePopupVisible(e.target.getClientRects()[0].top + e.target.clientHeight + 5 + 'px', e.clientX + 'px')
      }
    },
    onClick(data, e) {
      if (device.isMobile) {
        this.contestOrderHandsTotalList = this.weekOrTotal === 'week' ? data.contestOrderHandsWeekList : data.contestOrderHandsTotalList
        if (!this.contestOrderHandsTotalList.length) {
          return
        }

        this.handlePopupVisible(e.target.getClientRects()[0].top + e.target.clientHeight + 5 + 'px', e.clientX + 'px')
      }
    },
    handlePopupVisible(top, left) {
      this.timer = setTimeout(() => {
        this.showPopup = true
        this.$nextTick(() => {
          this.$refs.popup.style.top = top
          this.$refs.popup.style.left = left
        })
      }, 200)
    },
    onFixedRowFocus(id) {
      this.currentFocus = id
    },
    onInputEnter() {
      if (/\d/.test(this.localCurrent)) {
        this.localCurrent = parseInt(this.localCurrent);
        this.current = this.localCurrent;
      } else if (this.localCurrent.trim() === "") {
        this.current = 1;
      }
    },
    getOwnRanking() {
      if (!this.user) {
        return false;
      }

      const { group, weekOrTotal, week } = this;
      const fetcher = weekOrTotal === "total" ? getTotalRankingByUser : getWeekRankingByUser;

      fetcher({
        group,
        periodTime: weekOrTotal === "week" ? week : undefined
      }).then(async res => {
        if (res.data) {
          const userRes = await getUsersByIds({ ids: res.data.userId });

          this.ownRanking = {
            ...res.data,
            avatar: userRes.data[0].avatar,
            nick: userRes.data[0].nick
          };
        } else {
          this.ownRanking = {}
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getList() {
      const { current, group, weekOrTotal, size, week } = this;
      const fetcher = weekOrTotal === "total" ? getTopTotalRanking : getTopWeekRanking;
      const data = Object.assign(
        {},
        {
          current,
          group,
          size
        },
        weekOrTotal === "total" ? {} : { periodTime: week }
      );

      fetcher(data).then(async res => {
        const { total, pages } = res.data;
        const records = res.data

        if (records.length) {
          const ids = records.map(item => item.userId).join(",");
          const userRes = await getUsersByIds({ ids });
          const usersMap = userRes.data.reduce(
            (acc, cur) => Object.assign(acc, { [cur.id]: cur }),
            {}
          );

          records.forEach(item => {
            item.nick = usersMap[item.userId].nick;
            item.avatar = usersMap[item.userId].avatar;
          });


          // 设置总榜展示冠军文案
          if (this.weekOrTotal === 'total') {
            records.forEach(item => {

              if (!item.weekList) {
                return false
              }

              const weekRanking = item.weekList.map(item => item.ranking)

              // 获得两次冠军或以上
              const weekRankingLength = weekRanking.filter(w => w === 1).length
              if (weekRankingLength > 1) {

                // 是否连冠
                const rankingStr = weekRanking.join('')
                if (rankingStr.indexOf('11') >= -1) { // 存在连冠
                  const arr = rankingStr.match(/(\w)\1*/g) // ['11', '222', '111']
                  let maxLength = 0
                  arr.forEach(arrItem => {
                    if (arrItem.indexOf('1') >= 0) {
                      maxLength = arrItem.length > maxLength ? arrItem.length : maxLength
                    }
                  })

                  item.weekRanking = localStr[maxLength] + '连冠'
                } else {
                  
                  item.weekRanking = weekRankingLength + '周冠军'
                }

              } else { // 获得一次冠军
                const finded = item.weekList.find(item => item.ranking === 1)
                if (finded) {
                  const now = dayjs(finded.updateTime).valueOf()
                  for (let i = 0; i < this.weeksOptions.length; i++) {
                    const sub = this.weeksOptions[i]
                    const arr = sub.value.split('~')
                    const start = new Date(arr[0].replace(/-/g, '/') + ' 00:00:00')
                    const end = new Date(arr[1].replace(/-/g, '/') + ' 23:59:59')

                    if (now >= start && now <= end) {
                      item.weekRanking = sub.label + '冠军'
                      break
                    }
                  }
                }
              }

            })
          }
        }

        this.list = records;
        this.total = total;
        this.pages = pages || 1;

        if (res.data.length) {
          this.$emit(
            "updateTimeChange",
            records[0] ? records[0].updateTime : ""
          );
        }
      });
    },
    onPageChange(current) {
      if (current === 0 || current > this.pages) {
        return false;
      }

      this.current = current;
    },
    onPreventTouch(e) {
      e.preventDefault();
    },
    noop() {
      console.log('noop')
    }
  },
  watch: {
    current() {
      this.getList();
    },
    group() {
      this.current = 1;
      this.getList();
      this.getOwnRanking();
    },
    weekOrTotal() {
      this.current = 1;
      this.getList();
      this.getOwnRanking();
    },
    week() {
      this.current = 1;
      this.getList();
      this.getOwnRanking();
    },
    user() {
      this.getOwnRanking()
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  padding: 8px 14px;
  font-size: 14px;
  color: #ecc5bb;
  border: 1px solid #985e57;
  border-radius: 4px;
  background: #0f0a18;
  transform: translate(-50%, 0);

  .popup-container {
    white-space: nowrap;
  }
}

.custom-table {
  position: relative;
  width: 100%;

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  &.table {
    table-layout: fixed;
    margin-bottom: 0;
  }

  .cell-icon {
    width: 30px;
    vertical-align: middle;
  }

  .champion {
    width: 76px;
  }

  .total-champion {
    flex-shrink: 0;
    display: inline-block;
    width: 92px;
    height: 24px;
    padding-left: 15px;
    line-height: 23px;
    font-weight: 600;
    background: url('../../assets/total-champion.png') center/cover no-repeat;

    span {
      color: #fff;
      font-size: 12px;
      white-space: nowrap;
    }
  }

  &--header-wrapper,
  &--footer-wrapper {
    table {
      width: 100%;
    }

    th,
    td {
      font-weight: 500;
      color: #ebc4bc;
      font-size: 18px;
      background: rgba(42, 38, 49, 1);
    }
  }

  &--footer-wrapper {
    overflow: hidden;
    table {
      tr {
        td {
          background: #28191E;
        }
      }
      td {
        font-weight: 500;
        font-size: 18px;
      }
    }
  }

  &--body-wrapper {
    width: 100%;
    overflow: hidden;
    margin-top: -1px;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/

      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #0e0917;
    }

    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #161320;
    }

    table {
      width: 100%;
    }

    tr {
      background: rgba(22, 19, 32, 1);
      cursor: initial;
      user-select: none;

      &:nth-child(odd) {
        background: #1a1723;
      }
    }

    td {
      color: #ecc5bb;
      font-size: 14px;
    }

    .name-cell {
      text-align: left;
      word-break: break-all;
    }
  }

  &--body-wrapper.is-fixed {
    overflow-y: hidden;
  }

  &--fixed-wrapper {
    box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.1);
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 25%;

    table {
      width: 100%;
    }
  }

  td,
  th {
    white-space: nowrap;
    overflow: hidden;
    height: 42px;
    text-align: center;

    .cell {
      width: 100%;
      white-space: normal;
    }
  }
}
@media screen and (min-width: 1560px) {
  .custom-table {
    .cell {
      padding-left: 10% !important;
    }
  }
}

@media screen and (min-width: 799px) {
  .custom-table--body-wrapper {
    tr {
      &:hover {
        transition: all .3s;
        background: #3b3645;
      }
    }
  }
}

@include mobile {
  .popup {
    font-size: 12px;
    transform: translate(-100%, -50%);
    .popup-container {
      &>div {
        white-space: nowrap;
      }
    }
  }
  
  .custom-table {
    overflow: hidden;
    user-select: none;

    .cell-icon {
      width: 22px;
    }

    .cell-number {
      text-decoration: underline;
    }

    .total-champion {
      width: 78px;
      height: 20px;
      line-height: 19px;

      span {
        font-size: 10px;
      }
    }

    &--fixed-wrapper {
      overflow: hidden;

      .custom-table--header-wrapper,
      .custom-table--body-wrapper,
      .custom-table--footer-wrapper {
        position: relative;
        transform: translate3d(0, 0, 0);
        overflow: hidden;
      }

      .custom-table--footer-wrapper {
        td {
          font-size: 16px;
          font-weight: 600;
        }
      }
    }

    &--body-wrapper,
    &--header-wrapper,
    &--footer-wrapper {
      overflow: hidden;
    }

    table {
      td {
        font-size: 12px;
      }
      th {
        font-size: 14px;
        height: 36px;
      }
      td {
        height: 36px;
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .pagination {
    &-page {
      margin-right: 0;
    }

    &__input {
      width: 46px;
    }
  }
}
</style>
